var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.489 15.358 2.67 7.392s.334.691.692.691c.357 0 5.675-5.532 5.675-5.532L21.44 6.487 6.584 13.45l-.095 1.908z",
    fill: "#C8DAEA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m10.03 17.255-.513 5.449s-.214 1.67 1.455 0c1.67-1.67 3.267-2.957 3.267-2.957",
    fill: "#A9C6D8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m6.537 15.625-5.493-1.79s-.657-.266-.445-.87c.043-.124.13-.23.394-.413 1.217-.848 22.53-8.509 22.53-8.509s.602-.202.957-.068a.52.52 0 0 1 .353.386c.039.159.055.322.048.485-.002.141-.019.272-.032.477-.13 2.094-4.014 17.725-4.014 17.725s-.233.915-1.065.946a1.523 1.523 0 0 1-1.112-.43c-1.634-1.405-7.282-5.2-8.53-6.035a.239.239 0 0 1-.102-.17c-.018-.087.078-.196.078-.196S19.94 8.42 20.2 7.503c.02-.07-.056-.106-.159-.075-.653.24-11.976 7.391-13.226 8.18a.603.603 0 0 1-.278.017z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.429 .429)",
    d: "M0 0h27.143v27.143H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTgLogo);
export default __webpack_public_path__ + "static/media/tg-logo.51e2b9214f11f4ef42c04d6249a023de.svg";
export { ForwardRef as ReactComponent };